import { MediaType } from '@/common/models';
import { QueryParams } from '@/common/models/query-params';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetAllQuery, runQueryInScope } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_MEDIA_TYPES_LIST } from '@/org-app/store/modules/referenceData/mutation-types';

export const useMediaTypes = createGetAllQuery<MediaType>(
  [queryKeys.mediaTypes],
  () => OrgAppAPIProxy.instance.getMediaTypes({ queryParams: QueryParams.all() }),
  (data) => {
    orgAppStore.modules.ReferenceData.mutations[UPDATE_MEDIA_TYPES_LIST](orgAppStore.modules.ReferenceData.state, data);
  },
);

export const useMediaTypesFlatten = createGetAllQuery<MediaType>([queryKeys.mediaTypesFlatten], async () => {
  const mediaTypes = await runQueryInScope(useMediaTypes);
  const flattenMediaTypes: MediaType[] = [];
  for (const mediaType of mediaTypes) {
    flattenMediaTypes.push(mediaType.copy());
    for (const child of mediaType.children) {
      const childCopy = child.copy();
      childCopy.name = `${mediaType.name} > ${child.name}`;
      flattenMediaTypes.push(childCopy);
      for (const grandChild of child.children) {
        const grandChildCopy = grandChild.copy();
        grandChildCopy.name = `${childCopy.name} > ${grandChildCopy.name}`;
        flattenMediaTypes.push(grandChildCopy);
      }
    }
  }
  return flattenMediaTypes.sort((a, b) => a.name.localeCompare(b.name));
});
